import { render, staticRenderFns } from "./wx-msg-reply.vue?vue&type=template&id=226e811c&scoped=true"
import script from "./wx-msg-reply.vue?vue&type=script&lang=js"
export * from "./wx-msg-reply.vue?vue&type=script&lang=js"
import style0 from "./wx-msg-reply.vue?vue&type=style&index=0&id=226e811c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e811c",
  null
  
)

export default component.exports